// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".moving-images-text-input-answer[data-v-c042350c]{position:relative}.areas-for-images[data-v-c042350c]{margin-bottom:10px}.text-answer-wysiwyg[data-v-c042350c],.text-match-picker[data-v-c042350c]{margin-bottom:20px}.uploader[data-v-c042350c]{margin-bottom:16px}.images-match-picker[data-v-c042350c]{margin-bottom:20px}.left-border[data-v-c042350c]{position:absolute;top:0;left:-30px;width:4px;height:100%;background-color:#ebae28}", ""]);
// Exports
module.exports = exports;
